import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
// import { Modal, Button, Form } from "react-bootstrap";

import "react-toastify/dist/ReactToastify.css";

const FaultRepairAssignments = () => {
  const [loading, setLoading] = useState(false);
  const [EngineerEmail, setEngineerEmail] = useState("");
  const [numOfSr, setNumOfSr] = useState("");
  const [EngineerAssignments, setEngineerAssignments] = useState([]);
  const [EngineerAssignmentsView, setEngineerAssignmentsView] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [srList, setSrList] = useState([]);
  // const [noAssign,setNoAssign]=useState("");
  const highlightStyle = { border: '1px solid black' };

  const navigate = useNavigate();
  const redirectFaultRepairPage = () => {
    navigate("/faultRepair");
  };
  
  // const redirectMCpage = () => {
  //   navigate("/materialConsumeStatus");
  // };

  const redirectMCpage = async () => {
    const requestPayload = {
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      Action: "getCRMSRListByEmail",
      EngineerId: sessionStorage.getItem("userEmail")
    };

    try {
      // Replace 'YOUR_API_ENDPOINT_HERE' with your actual API endpoint
      const response = await fetch(process.env.REACT_APP_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestPayload)
      });
      const data = await response.json();

      if (data.Status === "Success") {
        setSrList(data.Response.SRList);
        setShowPopup(true);
      } else {
        console.error("API error:", data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };
  const redirectToViewAssignment = (e) => {
    // console.log("e", e);
    sessionStorage.setItem("ViewSR", e.srNumber);
    sessionStorage.setItem("CanId", e.customerID);
    sessionStorage.setItem("slotType", e.slotType);

    navigate("/faultRepairAssignmentView");
  };

  const redirectToViewAssignment1 = (sr) => {
    // Store SRno and CANId in session storage
    sessionStorage.setItem("ViewSR", sr.SRno);
    sessionStorage.setItem("CanId", sr.CANId);
    // Navigate to the assignment view page
    navigate("/materialConsumeStatus");
  };

  useEffect(() => {
    setEngineerEmail(sessionStorage.getItem("userEmail"));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "assignment",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          emailID: EngineerEmail,
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          // console.log("API Response of Assignments:", result);
          if (result && result.Status === "Success") {
            setEngineerAssignments(result.response);
            let sr = [];
            sr.push(result.response[0].srNumber);
            setNumOfSr(sr);
            // console.log("Assignments",result.response[0].srNumber );
            // console.log("Assignments SR",sr);
            setLoading(false);
          } else if (result && result.Status === "Failure") {
            toast.warning("At present there is no pending SR", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } else {
          console.error("Error fetching data:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (EngineerEmail) {
      fetchData();
    }
  }, [EngineerEmail]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        if (!Array.isArray(numOfSr)) {
          // console.error("numOfSr is not an array");
          return;
        }
        const srNumberList = numOfSr.map((srNumber) => ({
          srnumber: srNumber,
        }));
        const requestData = {
          Action: "getVisibilityDetails",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          srNumberList: srNumberList,
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });

        const result = await response.json();
        // console.log("API Response of getVisibilityDetails:", result.response[0]);
        if (result && result.Status === "Success") {
          setEngineerAssignmentsView(result.response[0]);
        } else {
          // const errorMessage = result && result.Status === "Success";
          toast.warning("Please wait...", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          setLoading(false);
        }

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [numOfSr]);

  const popupOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  };

  const popupContentStyle = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    width: '80%',
    maxWidth: '600px',
    position: 'relative'
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    // background: '#9465aa',
    border: 'none',
    fontSize: '16px',
    cursor: 'pointer'
  };

  const cardsContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '20px'
  };

  const cardStyle = {
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '10px',
    width: 'calc(50% - 10px)',
    boxSizing: 'border-box'
  };

  const handleAcknowledgeSR = async (srNumber) => {
    const url = process.env.REACT_APP_API_URL;
    const data = {
      "Action": "AcknowledgeSR",
      "ActionCode": "102-Field Engineer",
      "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      "ContactNo": "",
      "Contacted": "",
      "CustomerName": "",
      "ETR": "",
      "ETRReason": "",
      "EmailId": "",
      "EmpId": "",
      "EngId": "",
      "HoldReason": "",
      "Latitude": "",
      "Longitude": "",
      "RConeId": "",
      "RCthirdId": "",
      "RCtwoId": "",
      "ReasonOf": "",
      "ResolveContacted": "",
      "SlotType": "",
      "Source": "",
      "SrNumber": srNumber,
      "TaskType": "",
      "UpdatedBy": ""
    }

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      const responseData = await response.json();
      // console.log(responseData);
      // console.log("responseData.Status",responseData.Status)
      // if(responseData.Response.Message === "Acknowledgement updated successfully"){
      //   navigate("/faultRepairAssignmentView");
      // }
    } catch (error) {
      console.error('Error acknowledging service request:', error);
    }
  };





  return (
    <>
      
      <div className="p- text-light Header-style header">
        
          <div className="p-3">
            <span
              style={{ cursor: "pointer" }}
              onClick={redirectFaultRepairPage}
            >
              <i className="fa-solid fa-arrow-left-long"></i>
            </span>
            <span className="p-1 m-3">Your Assignments</span>

            <span
            onClick={redirectMCpage} className="flr-createCAf" style={{ fontSize: "12px" }}>Material Con. Status
          </span>
          </div>
         
       
      </div>
      {/* Popup displaying the SR cards */}
      {/* Popup with SR cards */}
      {showPopup && (
      //  <Modal >
      //     <Modal.Header closeButton style={{ backgroundColor: '#9465aa' }}>
      //         <Modal.Title style={{ color: '#ffffff' }}>Edit Item</Modal.Title>
      //     </Modal.Header>
      //     <Modal.Body>
        <div style={popupOverlayStyle}>
          <div style={popupContentStyle}>
            <button onClick={() => setShowPopup(false)} style={closeButtonStyle}>
              X
            </button>
            <h2>Material Con. Status</h2>
            {srList.map((sr, index) => (
              <div
                key={index}
                className="card mb-3"
                style={{
                  ...(sr.FRStatus === "Pending" ? highlightStyle : {}),
                  cursor: "pointer"
                }}
                onClick={() => redirectToViewAssignment1(sr)}
              >
                <div className="m-3 card-data">
                  <p className="card-text" style={{ fontSize: "20px" }}>
                    CAN Id: {sr.CANId}
                    <br />
                    SR No: {sr.SRno}
                    <br />
                    FR Status: {sr.FRStatus}
                    <br />
                    NRGP InNumber: {sr.NRGPInNumber}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        // </Modal.Body>

        // </Modal>

      )}

      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div className="container-fluid" style={{ marginTop: "95px" }}>
          <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
            {EngineerAssignments.map((assign, index) => (

              <div className="col" key={index}>
                <div className="card mb-3">
                  <div className="p-2 card-data">
                    <div>
                      <div className="assignment-card">
                        <div className="row">
                          <div className="col-5 text-weight-color">SR Number</div>
                          <div className="col-1">:</div>
                          <div className="col-6">{assign.srNumber}</div>
                        </div>
                        {/* <div className="card-data-row">
                          <span className="assignment-card-data-text">SR Number :</span>
                          <span className="assignment-card-data-value">
                            {assign.srNumber}
                          </span>
                        </div> */}

                        <div className=" repeatSr-text">
                          <span className="assignment-card-data">Repeat SR(In last 30 days) &nbsp;&nbsp;&nbsp; :</span>
                          <span className="assignment-card-data-value" style={{ marginLeft: "20px" }}>
                            {index + 1}
                          </span>
                        </div>

                        <div className="row">
                          <div className="col-5 text-weight-color">SLA Time </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {assign.slaClock}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-5 text-weight-color">CAN ID </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {assign.customerID}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-5 text-weight-color">Customer Name</div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {assign.customerName}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-5 text-weight-color">Mobile Number</div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {assign.customerMobile}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-5 text-weight-color">Slot Date Time</div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {assign.roasteDate} {assign.startTime}-
                            {assign.endTime}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-5 text-weight-color">Best Time To Reach</div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {EngineerAssignmentsView.BestTimeToReach}
                          </div>
                        </div>


                        <div className="row">
                          <div className="col-5 text-weight-color">Alternate Number</div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {EngineerAssignmentsView.AlternateNumber}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-5 text-weight-color">Alternate Email ID </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {EngineerAssignmentsView.AlternateEmailID}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-5 text-weight-color">Current Status  </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {assign.srStatus}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-5  text-weight-color">Address </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {assign.customerAddress}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-5 text-weight-color">Account Turnover </div>
                          <div className="col-1">:</div>
                          <div className="col-6">
                            {assign.accountTurnOver}
                          </div>
                        </div>


                        <div className="row">
                          <div className="col-8">Internal Customer Category &nbsp;&nbsp; :</div>
                          {/* <div className="col-1">:</div> */}
                          <div className="col-4">
                            {assign.customerCategory}
                          </div>
                        </div>

                      </div>

                      <div className=" text-center mt-5 mb-4">
                        <button
                          type="submit"
                          className="btn text-light w-75 bg-dark mx-auto rounded-pill"
                          onClick={() => redirectToViewAssignment(assign)}
                        >
                          View
                        </button>
                      </div>

                      <div className=" text-center mb-4">
                        <button
                          type="submit"
                          className="btn text-light w-75 bg-dark mx-auto rounded-pill"
                          onClick={() => handleAcknowledgeSR(assign.srNumber)}
                        >
                          Acknowledge
                        </button>
                      </div>

                      <div className=" text-center mb-3">
                        <button
                          type="submit"
                          className="btn text-light w-75 bg-dark mx-auto rounded-pill"
                        >
                          Add Infra Details
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default FaultRepairAssignments;
